<app-profile-header></app-profile-header>
<mat-dialog-content>
  <app-profile-modal-entries
    [entries]="entries"
    type="income"
  ></app-profile-modal-entries>
  <app-notification variant="warning"
    ><p class="be-body-s text-navy-800">
    Please make sure you entered the right number.
  </p></app-notification
  >
</mat-dialog-content>
<mat-dialog-actions>
  @if (isErroneouslySubmitted) {
    <app-notification
      variant="error"
      class="block my-3"
      >
      <p class="mb-0">Couldn't update income.</p>
    </app-notification>
  }
  <app-profile-confirmation-footer
    [isSubmitted]="isSuccessfullySubmitted"
    [isSubmitting]="isSubmitting"
    (onConfirm)="updateIncome()"
    (onCancel)="onCancel()"
  ></app-profile-confirmation-footer>

  @if (isSuccessfullySubmitted) {
    <app-notification
      variant="success"
      class="block mt-1"
      >
      <p class="m-0">Income successfully updated!</p>
    </app-notification>
  }
</mat-dialog-actions>
